import { createAction, props } from '@ngrx/store';
export const setNamingConvention = createAction('[Custom PDF Report Modal] Set Naming Convention', props());
